import { SendHitsEvent } from './const';

export const sendAlgoliaClickEvent = (sendEvent: SendHitsEvent, hit) => {
  if (sendEvent) {
    sendEvent('click', hit, 'Hit clicked');
  }
};
